const GOOGLE_MAP_API_KEY = 'AIzaSyCeN2RU_2SPpd64Gt3r5UOrELCTR8afwas';

/**
 * Google Map on the single Racecourse template
 */
window.initRacecourseMap = function() {
    var mapContainer = document.getElementById("racecourse-map");

    if (!mapContainer) return;

    var title = mapContainer.dataset.title;
    var lat = parseFloat(mapContainer.dataset.lat);
    var lng = parseFloat(mapContainer.dataset.lng);

    if (!isNaN(lat) && !isNaN(lng)) {
        const map = new google.maps.Map(mapContainer, {
            zoom: 15,
            center: { lat: lat, lng: lng },
            mapId: "YOUR_MAP_ID", // Replace with your actual Map ID
        });

        const { AdvancedMarkerElement } = google.maps.marker;

        // Create the marker
        const marker = new AdvancedMarkerElement({
            position: { lat: lat, lng: lng },
            map: map,
        });

        // Create the info window
        const infoWindow = new google.maps.InfoWindow({
			content: `
				<div class="racecourse-map-infowindow">
					<a href="https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}" target="_blank">Get directions</a>
				</div>
			`,
		});

        // Add a click event listener to the marker
        marker.addListener("gmp-click", () => {
            infoWindow.open(map, marker);
        });
    } else {
        console.error("Invalid coordinates provided.");
    }
};

function loadGoogleMapsAPI() {
    if (window.google && window.google.maps) {
        window.initRacecourseMap(); // If API is already loaded, just initialize the map
        return;
    }

    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key="+GOOGLE_MAP_API_KEY+"&libraries=marker&callback=initRacecourseMap&loading=async";
    script.async = true;
    script.defer = true;
    script.onerror = function() {
        console.error("Failed to load Google Maps API.");
    };
    document.head.appendChild(script);
}

document.addEventListener("DOMContentLoaded", loadGoogleMapsAPI);


/**
 * Live filtering on the Racecourses page
 */
document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('racecourse-search-input');

    if (!searchInput) return;

    const racecourseList = document.getElementById('racecourse-list');
    const racecourseItems = racecourseList.getElementsByTagName('li');
    const noResultsMessage = document.getElementById('no-results-message');
    const resetSearchLink = document.getElementById('reset-search');

    // Debounce function to limit how often the filter runs
    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    // Filter function
    function filterRacecourses() {
        const searchTerm = searchInput.value.trim().toLowerCase();
        let hasMatches = false;

        // Only filter if the user has typed at least 2 characters
        if (searchTerm.length < 2) {
            // Show all items if the search term is too short
            Array.from(racecourseItems).forEach(item => {
                item.style.display = '';
            });
            noResultsMessage.style.display = 'none'; // Hide the "No results" message
            return;
        }

        // Filter the list
        Array.from(racecourseItems).forEach(item => {
            const racecourseName = item.textContent.toLowerCase();
            if (racecourseName.includes(searchTerm)) {
                item.style.display = '';
                hasMatches = true; // At least one item matches
            } else {
                item.style.display = 'none';
            }
        });

        // Show or hide the "No results" message
        if (hasMatches) {
            noResultsMessage.style.display = 'none';
        } else {
            noResultsMessage.style.display = 'block';
        }
    }

    // Reset function
    function resetSearch() {
        searchInput.value = ''; // Clear the search input
        Array.from(racecourseItems).forEach(item => {
            item.style.display = ''; // Show all items
        });
        noResultsMessage.style.display = 'none'; // Hide the "No results" message
    }

    // Attach the debounced filter function to the input event
    searchInput.addEventListener('input', debounce(filterRacecourses, 300));

    // Attach the reset function to the Reset link
    resetSearchLink.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent the link from navigating
        resetSearch();
    });
});